import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { XplentyConsoleComponent } from './components/xplenty-console.component';
import { XplentyConsoleShortcutsComponent } from './components/xplenty-console-shortcuts.component';
import { XplentyConsoleFunctionsComponent } from './components/xplenty-console-functions.component';

@NgModule({
  imports: [BrowserModule, UpgradeModule, HttpClientModule, MatDialogModule, FormsModule],
  providers: [],
  declarations: [XplentyConsoleComponent, XplentyConsoleShortcutsComponent, XplentyConsoleFunctionsComponent],
  entryComponents: [XplentyConsoleComponent, XplentyConsoleShortcutsComponent, XplentyConsoleFunctionsComponent],
})
export class HelpModule {}
